// angular
import { Component, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@app/core/components/button/button.component';
import { LoginDialogComponent } from '@app/core/dialogs/login-dialog/login-dialog.component';
import { DialogService } from '@app/core/shared/services/dialog.service';
import { ITender } from '@tenders/shared/interfaces/tender.interface';

@Component({
  selector: 'pwj-tender-submit-quote-tab',
  standalone: true,
  imports: [TranslateModule, ButtonComponent, RouterLink],
  templateUrl: './tender-submit-quote-tab.component.html',
  styleUrl: './tender-submit-quote-tab.component.scss',
})
export class TenderSubmitQuoteTabComponent {
  tender = input.required<ITender>();
  isActive = input<boolean>(false);
  isUserLoggedIn = input<boolean>(false);

  submitQuote = output<void>();

  private readonly _dialogService = inject(DialogService);

  public openLoginDialog(): void {
    this._dialogService.open(LoginDialogComponent, {
      width: 'none',
      height: 'none',
    });
  }
}
